"use strict";

module.exports = {
  front_name: 'Deltex',
  back_name: 'Deltex',
  logo: '/images/deltex_full.png',
  dev_url: 'http://localhost:3108/',
  prod_url: 'https://app.3ddx.fr/',
  pre_prod_url: 'https://deltex.panda-one.dev/',
  // In development, override all email addresses
  DEV_EMAIL: 'patxi@panda-one.fr',
  admin_receiver: ['juliendx@earthlink.net'],
  admin_sender: 'DELTEX <noreply@earthlink.net>',
  default_home: 'UserHomePage',
  languages: [{
    ISO: 'FR',
    label: 'Français'
  }],
  js_version: '1.0.1'
};
